<template>
  <div>
    <!-- Dialog to Create & Edit a attachments -->
    <Dialog
      :key="formKey"
      :visible.sync="attachmentForm1"
      :style="{ width: '640px', overflowY: 'auto' }"
      header="Attachment Details"
      :modal="true"
      class="p-fluid"
      v-cloak
      @drop.prevent="addFile"
      @dragover.prevent
    >
      <div class="p-formgrid p-grid" v-if="isAttachmentPresent()">
        <div class="p-field p-col-12" style="text-align: center;">
          <p>You can also drop the file in this form</p>
        </div>
      </div>

      <div class="p-formgrid p-grid">
        <div class="p-field p-col relative">
          <label for="noteHeader">File Name:</label>
          <div class="p-grid">
            <div class="p-col-12 p-lg-12">
              <div class="p-inputgroup">
                <InputText
                  id="noteHeader"
                  v-model.trim="file.name"
                  required="true"
                  :disabled="true"
                  autofocus
                />
                <Button
                  :disabled="isAttachmentPresent()"
                  icon="pi pi-download"
                  @click="download"
                />
                <Button
                  :disabled="!file.name"
                  class="p-button-danger p-mx-2"
                  icon="pi pi-times"
                  @click="clearFile"
                />
                <Button
                  label="Add file"
                  class="p-button-info"
                  icon="pi pi-plus"
                  @click="clickButton"
                  iconPos="right"
                  :disabled="!isAttachmentPresent()"
                />
                <input
                  single
                  type="file"
                  id="image1"
                  style="display: none;"
                  accept="*/*"
                  @change="onFileSelect"
                  :disabled="!isAttachmentPresent()"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-danger"
          style="width: 100px;"
          @click="hideDialog"
        />
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;"
          strokeWidth="5"
          fill="#EEEEEE"
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Save"
          icon="pi pi-check"
          class="p-button-success"
          style="width: 100px;"
          @click="saveAttachment"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import AttachmentService from "@/service/AttachmentService";

import { attachmentRequest } from "../sendRequest";

export default {
  props: ["attachment", "attachmentForm", "reloadForm"],
  data: () => ({
    attachmentService: new AttachmentService(),
    file: {},
    thisAttachment: {},
    submitted: false,
    sendingRequest: false,
    formKey: 0
  }),
  computed: {
    attachmentForm1: {
      set(val) {
        if (!val) {
          this.hideDialog();
        }
      },
      get() {
        return this.attachmentForm;
      }
    }
  },
  created() {},
  watch: {
    attachment(val) {
      this.thisAttachment = val;
    },
    reloadForm() {
      this.formKey++;
    }
  },
  methods: {
    onFileSelect(e) {
      if (e.target.files && e.target.files[0]) {
        if (e.target.files[0].size < 10485760) {
          this.file = e.target.files[0];
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Big file",
            detail: "File size is greater than 10MB.",
            life: 5000
          });
        }
      }
    },
    clickButton() {
      document.getElementById("image1").click();
    },
    saveAttachment() {
      this.submitted = true;

      if (this.file && this.file.name) {
        this.attachmentService
          .postFile(this.file, { fileName: this.file.name })
          .then(res => {
            this.submitted = false;

            if (res && res.status === 200) {
              this.$toast.add({
                severity: "success",
                summary: res.data,
                detail: "File uploaded",
                life: 5000
              });
            }
          })
          .catch(err => {
            this.submitted = false;

            if (err && err.response && err.response.data) {
              if (
                err.response.data.includes("exceeds the configured maximum")
              ) {
                this.$toast.add({
                  severity: "error",
                  summary: "File too big.",
                  detail: "File size exceeds the limited size.",
                  life: 5000
                });
              }
            }
          });
      }
    },
    hideDialog() {
      this.$emit("close");
    },
    clearFile() {
      this.file = {};
    },
    download() {
      // this.attachmentService
      //   .fileDownloader(this.thisAttachment.fileName)
    },
    isAttachmentPresent() {
      return this.attachment && this.attachment.fileName ? false : true;
    },
    addFile(e) {
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;

      let a = droppedFiles[0];
      //
      a.fileName = a.name;
      this.file = a;
    }
  }
};
</script>

<style></style>
